module.exports = require("@ont-dev/hdkey-secp256r1");